var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cells",staticStyle:{"background-color":"blue","font-size":"46px"}},_vm._l((_vm.positions),function(position,i){return _c('Cell',{key:i,attrs:{"index":i,"position":position,"replay":_vm.replay}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }